import { CheckCircleIcon } from "@heroicons/react/24/solid";

const frontend = [
  {
    name: "HTML/CSS",
    icon: CheckCircleIcon,
  },
  {
    name: "React",
    icon: CheckCircleIcon,
  },
  {
    name: "Selenium",
    icon: CheckCircleIcon,
  },
  {
    name: "TailwindCSS",
    icon: CheckCircleIcon,
  },
];

const backend = [
  {
    name: "Java",
    icon: CheckCircleIcon,
  },
  {
    name: "Python",
    icon: CheckCircleIcon,
  },
  {
    name: "Flask APIs",
    icon: CheckCircleIcon,
  },
  {
    name: "Spring Boot",
    icon: CheckCircleIcon,
  },
];

const collab = [
  {
    name: "Git",
    icon: CheckCircleIcon,
  },
  {
    name: "Jira",
    icon: CheckCircleIcon,
  },
  {
    name: "Agile",
    icon: CheckCircleIcon,
  },
  {
    name: "Scrum",
    icon: CheckCircleIcon,
  },
];

const data = [
  {
    name: "Numpy",
    icon: CheckCircleIcon,
  },
  {
    name: "MatPlotLib",
    icon: CheckCircleIcon,
  },
  {
    name: "Pandas",
    icon: CheckCircleIcon,
  },
  {
    name: "SQL",
    icon: CheckCircleIcon,
  },
];

export default function Skills() {
  return (
    <div className="py-24 sm:py-32" id="skills">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p className="mt-2 text-4xl font-bold tracking-tight sm:text-6xl">
            Skills
          </p>
        </div>
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:gap-y-10">
          {[frontend, backend, collab, data].map((category, index) => (
            <div
              key={index}
              className="mt-10 max-w-2xl sm:mt-10 lg:mt-10 lg:max-w-4xl bg-base-200 ring-2 ring-base-300 rounded-2xl p-5 shadow-xl"
              data-aos="zoom-in"
            >
              <p className="text-2xl text-center font-bold mb-6">
                {index === 0 && "Web Development"}
                {index === 1 && "Backend Development"}
                {index === 2 && "Collaborative Technologies"}
                {index === 3 && "Data Analytics"}
              </p>
              <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-6 lg:max-w-none lg:grid-cols-2 lg:gap-y-6">
              {category.map((skill) => (
                <div key={skill.name} className="relative pl-16">
                  <dt className="text-base font-semibold leading-7 flex items-center">
                    <div className="absolute left-0 top-1/2 -translate-y-1/2 flex h-10 w-10 items-center justify-center rounded-lg">
                      <skill.icon className="h-6 w-6" aria-hidden="true" />
                    </div>
                    <span className="relative top-[1px]">{skill.name}</span>
                  </dt>
                </div>
              ))}
              </dl>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}